import { uploadImage } from '../api/uploadApi';
import { showErrorPopup } from './notification-actions';

export const uploadTempPhoto = (values, usePng) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'UPLOAD:TEMP_PHOTO',
            usePng: usePng || false,
        });
        const res = await uploadImage(mainApi, values);
        dispatch({
            type: 'UPLOAD:TEMP_PHOTO_SUCCESS',
            res,
        });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error uploading image.',
            error: err,
        }));
        throw err;
    }
};

export const clearTempPhoto = (usePng) => async (dispatch) => {
    dispatch({
        type: 'UPLOAD:CLEAR_TEMP_PHOTO',
        usePng: usePng || false,
    });
};
